import { create } from 'apisauce';
import { getAuthToken } from 'utils/cookies';

const token = getAuthToken();
const client = create({
  baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/onboarding`,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Authorization': `Bearer ${token}`,
  },
});

const fetchOnBoardData = async () => {
  const response = await client.get('', {});
  const { data } = response;
  return data;
};

const saveOnBoardData = async ({ boarding }) => {
  const response = await client.put('', boarding);
  const { status } = response;
  return status === 200;
};

const finishBoarding = async () => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/onboarding/done`,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': `Bearer ${token}`,
    },
  });

  try {
    const response = await api.post('', {});
    const { status } = response;
    return status === 200;
  } catch (err) {
    return false;
  }
};

export {
  fetchOnBoardData,
  saveOnBoardData,
  finishBoarding,
};
